import { defaultVelasProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/velas/default-constants';

export const ASTRO_SWAP_CONTRACT_ADDRESS = '0x3328cd3a9A295cd00fBb1d71Bf097e002B4614ad';

export const ASTRO_SWAP_PROVIDER_CONFIGURATION = defaultVelasProviderConfiguration;
